import { ReactNode } from 'react';
import { useRouter } from 'next/router';

import { CookieNotice } from '@/shared/components/precision/cookie-notice';

import { Footer } from './footer';
import { Header } from './header';

export const MainLayout = ({ children }: { children: ReactNode }) => {
  const { pathname } = useRouter();
  const document = ['/privacy-policy', '/personal-data', '/offer', '/requisites', '/delivery-and-payment'].includes(
    pathname,
  );
  return (
    <div className="precision-site">
      <Header />
      <main
        id="main"
        className={`site-main ${pathname === '/' ? 'site-main--home' : 'site-main--inner'}${
          document ? ' site-main--document' : ''
        }`}
        data-page={pathname}
      >
        {children}
      </main>
      <Footer />
      <CookieNotice />
    </div>
  );
};
